"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OperationTabContent;
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@synerg/react-components");
var _lodash = require("lodash");
require("ag-grid-community/dist/styles/ag-theme-alpine.css");
require("ag-grid-community/dist/styles/ag-grid.css");
var _requestTabContent = _interopRequireDefault(require("./requestTabContent"));
var _responseTabContent = _interopRequireDefault(require("./responseTabContent"));
var _examplesTabContent = _interopRequireDefault(require("./examplesTabContent/examplesTabContent"));
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var requestTabValue = 'request';
var responsesTabValue = 'responses';
var examplesTabValue = 'example(s)';
var headersTabValue = 'headers';
var parametersTabValue = 'parameters';
var previewTabValue = 'preview';
function OperationTabContent(_ref) {
  var _ref$operationDetails = _ref.operationDetails,
    operationDetails = _ref$operationDetails === void 0 ? {} : _ref$operationDetails,
    description = _ref.description,
    customClassNamesRequestTab = _ref.customClassNamesRequestTab;
  var dtrum = global.window.dtrum;
  var _useState = (0, _react.useState)(requestTabValue),
    _useState2 = _slicedToArray(_useState, 2),
    operationLeftMenuTabValue = _useState2[0],
    setOperationLeftMenuTabValue = _useState2[1];
  var _useState3 = (0, _react.useState)(headersTabValue),
    _useState4 = _slicedToArray(_useState3, 2),
    requestSectionTabValue = _useState4[0],
    setRequestSectionTabValue = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    headersTabRowData = _useState6[0],
    setHeadersTabRowData = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    parametersTabRequiredRowData = _useState8[0],
    setParametersTabRequiredRowData = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    parametersTabOptionalRowData = _useState10[0],
    setParametersTabOptionalRowData = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    previewTabData = _useState12[0],
    setPreviewTabData = _useState12[1];
  var gridApiRef = (0, _react.useRef)();
  var gridParamApiRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    setHeadersTabRowData((0, _lodash.get)(operationDetails, 'request.header', []));
    setParametersTabRequiredRowData((0, _lodash.get)(operationDetails, 'request.parameters.required', []));
    setParametersTabOptionalRowData((0, _lodash.get)(operationDetails, 'request.parameters.optional', []));
    setPreviewTabData((0, _lodash.get)(operationDetails, 'request.preview', ''));
  }, [operationDetails]);
  var onLeftMenuTabChange = function onLeftMenuTabChange(value) {
    setOperationLeftMenuTabValue(value);
    if (value === requestTabValue) {
      var actionId = dtrum === null || dtrum === void 0 ? void 0 : dtrum.enterAction('api_request', 'tab');
      console.log('Dtrum action id on request tab click - ', actionId);
      // set initial tab value to be active (headers for request section)
      setRequestSectionTabValue(headersTabValue);
      dtrum === null || dtrum === void 0 ? void 0 : dtrum.leaveAction(actionId);
    } else if (value === responsesTabValue) {
      var _actionId = dtrum === null || dtrum === void 0 ? void 0 : dtrum.enterAction('api_response', 'tab');
      console.log('Dtrum action id on response tab click - ', _actionId);
      dtrum === null || dtrum === void 0 ? void 0 : dtrum.leaveAction(_actionId);
    } else if (value === examplesTabValue) {
      var _actionId2 = dtrum === null || dtrum === void 0 ? void 0 : dtrum.enterAction('api_example', 'tab');
      console.log('Dtrum action id on example tab click - ', _actionId2);
      dtrum === null || dtrum === void 0 ? void 0 : dtrum.leaveAction(_actionId2);
    }
  };
  var onRequestSectionTabChange = function onRequestSectionTabChange(value) {
    setRequestSectionTabValue(value);
  };
  var isRequestTabSelected = operationLeftMenuTabValue === requestTabValue;
  var isResponseTabSelected = operationLeftMenuTabValue === responsesTabValue;
  var isExamplesTabSelected = operationLeftMenuTabValue === examplesTabValue;
  var cellStyle = {
    'fontWeight': '100',
    'color': '#262321',
    'whiteSpace': 'normal',
    'overflow': 'auto',
    'height': 'auto',
    'lineHeight': '1.5rem',
    'padding': '1rem',
    'wordBreak': 'break-word'
  };
  var _useState13 = (0, _react.useState)([{
      field: 'key',
      headerName: 'Key',
      wrapText: true,
      autoHeight: true,
      cellStyle: cellStyle
    }, {
      field: 'value',
      headerName: 'Value',
      wrapText: true,
      autoHeight: true,
      cellStyle: _objectSpread(_objectSpread({}, cellStyle), {}, {
        'fontFamily': 'Monaco',
        'fontSize': '14px'
      })
    }, {
      field: 'dataFormat',
      headerName: 'Data format',
      wrapText: true,
      autoHeight: true,
      cellStyle: cellStyle
    }]),
    _useState14 = _slicedToArray(_useState13, 1),
    headersTabColumnDefs = _useState14[0];
  var _useState15 = (0, _react.useState)([{
      field: 'name',
      headerName: 'Name',
      wrapText: true,
      autoHeight: true,
      cellStyle: cellStyle,
      width: 190
    }, {
      field: 'type',
      headerName: 'Type',
      cellStyle: cellStyle,
      autoHeight: true,
      wrapText: true,
      width: 120
    }, {
      field: 'format',
      headerName: 'Format',
      cellStyle: cellStyle,
      autoHeight: true,
      wrapText: true,
      width: 120
    }, {
      field: 'description',
      headerName: 'Description',
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      flex: 1
    }]),
    _useState16 = _slicedToArray(_useState15, 1),
    parametersTabColumnDefs = _useState16[0];
  var defaultColDef = (0, _react.useMemo)(function () {
    return {
      wrapHeaderText: true,
      suppressMovable: true,
      suppressSizeToFit: true,
      filter: false,
      suppressMenu: true
    };
  }, []);
  var previewTabDataFormatted = function previewTabDataFormatted(previewTabData) {
    if (previewTabData) {
      var previewReplaceContent = previewTabData.replace(/[ ]{3}/g, '\n  ');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "overflow-auto whitespace-pre-wrap break-all"
      }, previewReplaceContent);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "operation-tab-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-02 font-bold mt-4 mb-2"
  }, "Description"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-body-02 mb-8",
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(description)
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4 lg:grid lg:grid-cols-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-min sm:col-end-1 mb-8 flex lg:w-48"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTabGroup, {
    vertical: true,
    size: "small",
    role: "tablist",
    onSdfChange: function onSdfChange(event) {
      return onLeftMenuTabChange(event.detail.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: requestTabValue,
    className: "vertical-tab layout-vertical size-small first-in-group",
    role: "tab",
    active: isRequestTabSelected
  }, "Request"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: responsesTabValue,
    className: "vertical-tab layout-vertical size-small middle-in-group",
    role: "tab",
    active: isResponseTabSelected
  }, "Response(s)"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: examplesTabValue,
    className: "vertical-tab layout-vertical size-small last-in-group",
    role: "tab",
    active: isExamplesTabSelected
  }, "Example(s)"))), isRequestTabSelected && /*#__PURE__*/_react.default.createElement(_requestTabContent.default, {
    onRequestSectionTabChange: onRequestSectionTabChange,
    headersTabValue: headersTabValue,
    requestSectionTabValue: requestSectionTabValue,
    parametersTabValue: parametersTabValue,
    previewTabValue: previewTabValue,
    gridApiRef: gridApiRef,
    headersTabRowData: headersTabRowData,
    headersTabColumnDefs: headersTabColumnDefs,
    gridParamApiRef: gridParamApiRef,
    parametersTabOptionalRowData: parametersTabOptionalRowData,
    parametersTabRequiredRowData: parametersTabRequiredRowData,
    parametersTabColumnDefs: parametersTabColumnDefs,
    previewTabData: previewTabData,
    previewTabDataFormatted: previewTabDataFormatted,
    defaultColDef: defaultColDef,
    customClassNamesRequestTab: customClassNamesRequestTab
  }), isResponseTabSelected && /*#__PURE__*/_react.default.createElement(_responseTabContent.default, {
    operationDetailsResponse: (0, _lodash.get)(operationDetails, 'response', null),
    operationPath: (0, _lodash.get)(operationDetails, 'operationPath', ''),
    httpMethod: (0, _lodash.get)(operationDetails, 'httpMethod', '')
  }), isExamplesTabSelected && /*#__PURE__*/_react.default.createElement(_examplesTabContent.default, {
    operationDetailsExamples: (0, _lodash.get)(operationDetails, 'example', null),
    operationPath: (0, _lodash.get)(operationDetails, 'operationPath', ''),
    httpMethod: (0, _lodash.get)(operationDetails, 'httpMethod', '')
  })));
}